import context from '../context'
// import getComponentKey from '@/utils/getComponentKey'
import { allowErrorDialog } from '@/utils/fetch'

export const initialState = {
  fetching: false,
  updating: false,
  legacyCode: null
}

export const actionTypes = {
  fetching: 'phoneNumber/fetching',
  fetched: 'phoneNumber/fetched',
  updating: 'phoneNumber/updating',
  updated: 'phoneNumber/updated',
  error: 'phoneNumber/error'
}

export const actionCreators = {
  getLegacyCode: (id) => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.userManagementService.getLegacyCode(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, payload: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  updateLegacyCode: (input) => (dispatch) => {
    dispatch({ type: actionTypes.updating })
    context.api.userManagementService.updateLegacyCode(input, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.updated, payload: input })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { updating: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, legacyCode: action.payload.legacyCode }

    case actionTypes.updating: return { ...state, updating: true }
    case actionTypes.updated: return { ...state, updating: false, legacyCode: action.payload.legacyCode }
    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/userLegacyCode.js